/**
 * @fileoverview gRPC-Web generated client stub for 
 * @enhanceable
 * @public
 */

// Code generated by protoc-gen-grpc-web. DO NOT EDIT.
// versions:
// 	protoc-gen-grpc-web v1.5.0
// 	protoc              v3.20.3
// source: adminbackendproto/AdminQuestionService.proto


/* eslint-disable */
// @ts-nocheck


import * as grpcWeb from 'grpc-web';

import * as adminbackendproto_AdminQuestionService_pb from '../adminbackendproto/AdminQuestionService_pb'; // proto import: "adminbackendproto/AdminQuestionService.proto"
import * as backendproto_QuestionService_pb from '../backendproto/QuestionService_pb'; // proto import: "backendproto/QuestionService.proto"


export class AdminQuestionServiceClient {
  client_: grpcWeb.AbstractClientBase;
  hostname_: string;
  credentials_: null | { [index: string]: string; };
  options_: null | { [index: string]: any; };

  constructor (hostname: string,
               credentials?: null | { [index: string]: string; },
               options?: null | { [index: string]: any; }) {
    if (!options) options = {};
    if (!credentials) credentials = {};
    options['format'] = 'text';

    this.client_ = new grpcWeb.GrpcWebClientBase(options);
    this.hostname_ = hostname.replace(/\/+$/, '');
    this.credentials_ = credentials;
    this.options_ = options;
  }

  methodDescriptorCheckLogin = new grpcWeb.MethodDescriptor(
    '/AdminQuestionService/CheckLogin',
    grpcWeb.MethodType.UNARY,
    adminbackendproto_AdminQuestionService_pb.CheckLoginRequest,
    adminbackendproto_AdminQuestionService_pb.CheckLoginResponse,
    (request: adminbackendproto_AdminQuestionService_pb.CheckLoginRequest) => {
      return request.serializeBinary();
    },
    adminbackendproto_AdminQuestionService_pb.CheckLoginResponse.deserializeBinary
  );

  checkLogin(
    request: adminbackendproto_AdminQuestionService_pb.CheckLoginRequest,
    metadata?: grpcWeb.Metadata | null): Promise<adminbackendproto_AdminQuestionService_pb.CheckLoginResponse>;

  checkLogin(
    request: adminbackendproto_AdminQuestionService_pb.CheckLoginRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.RpcError,
               response: adminbackendproto_AdminQuestionService_pb.CheckLoginResponse) => void): grpcWeb.ClientReadableStream<adminbackendproto_AdminQuestionService_pb.CheckLoginResponse>;

  checkLogin(
    request: adminbackendproto_AdminQuestionService_pb.CheckLoginRequest,
    metadata?: grpcWeb.Metadata | null,
    callback?: (err: grpcWeb.RpcError,
               response: adminbackendproto_AdminQuestionService_pb.CheckLoginResponse) => void) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ +
          '/AdminQuestionService/CheckLogin',
        request,
        metadata || {},
        this.methodDescriptorCheckLogin,
        callback);
    }
    return this.client_.unaryCall(
    this.hostname_ +
      '/AdminQuestionService/CheckLogin',
    request,
    metadata || {},
    this.methodDescriptorCheckLogin);
  }

  methodDescriptorGetAllQuestions = new grpcWeb.MethodDescriptor(
    '/AdminQuestionService/GetAllQuestions',
    grpcWeb.MethodType.UNARY,
    backendproto_QuestionService_pb.GetQuestionsRequest,
    backendproto_QuestionService_pb.GetQuestionsResponse,
    (request: backendproto_QuestionService_pb.GetQuestionsRequest) => {
      return request.serializeBinary();
    },
    backendproto_QuestionService_pb.GetQuestionsResponse.deserializeBinary
  );

  getAllQuestions(
    request: backendproto_QuestionService_pb.GetQuestionsRequest,
    metadata?: grpcWeb.Metadata | null): Promise<backendproto_QuestionService_pb.GetQuestionsResponse>;

  getAllQuestions(
    request: backendproto_QuestionService_pb.GetQuestionsRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.RpcError,
               response: backendproto_QuestionService_pb.GetQuestionsResponse) => void): grpcWeb.ClientReadableStream<backendproto_QuestionService_pb.GetQuestionsResponse>;

  getAllQuestions(
    request: backendproto_QuestionService_pb.GetQuestionsRequest,
    metadata?: grpcWeb.Metadata | null,
    callback?: (err: grpcWeb.RpcError,
               response: backendproto_QuestionService_pb.GetQuestionsResponse) => void) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ +
          '/AdminQuestionService/GetAllQuestions',
        request,
        metadata || {},
        this.methodDescriptorGetAllQuestions,
        callback);
    }
    return this.client_.unaryCall(
    this.hostname_ +
      '/AdminQuestionService/GetAllQuestions',
    request,
    metadata || {},
    this.methodDescriptorGetAllQuestions);
  }

  methodDescriptorSaveInteriorQuestions = new grpcWeb.MethodDescriptor(
    '/AdminQuestionService/SaveInteriorQuestions',
    grpcWeb.MethodType.UNARY,
    adminbackendproto_AdminQuestionService_pb.SaveInteriorQuestionsRequest,
    adminbackendproto_AdminQuestionService_pb.SaveInteriorQuestionsResponse,
    (request: adminbackendproto_AdminQuestionService_pb.SaveInteriorQuestionsRequest) => {
      return request.serializeBinary();
    },
    adminbackendproto_AdminQuestionService_pb.SaveInteriorQuestionsResponse.deserializeBinary
  );

  saveInteriorQuestions(
    request: adminbackendproto_AdminQuestionService_pb.SaveInteriorQuestionsRequest,
    metadata?: grpcWeb.Metadata | null): Promise<adminbackendproto_AdminQuestionService_pb.SaveInteriorQuestionsResponse>;

  saveInteriorQuestions(
    request: adminbackendproto_AdminQuestionService_pb.SaveInteriorQuestionsRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.RpcError,
               response: adminbackendproto_AdminQuestionService_pb.SaveInteriorQuestionsResponse) => void): grpcWeb.ClientReadableStream<adminbackendproto_AdminQuestionService_pb.SaveInteriorQuestionsResponse>;

  saveInteriorQuestions(
    request: adminbackendproto_AdminQuestionService_pb.SaveInteriorQuestionsRequest,
    metadata?: grpcWeb.Metadata | null,
    callback?: (err: grpcWeb.RpcError,
               response: adminbackendproto_AdminQuestionService_pb.SaveInteriorQuestionsResponse) => void) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ +
          '/AdminQuestionService/SaveInteriorQuestions',
        request,
        metadata || {},
        this.methodDescriptorSaveInteriorQuestions,
        callback);
    }
    return this.client_.unaryCall(
    this.hostname_ +
      '/AdminQuestionService/SaveInteriorQuestions',
    request,
    metadata || {},
    this.methodDescriptorSaveInteriorQuestions);
  }

  methodDescriptorSaveExteriorQuestions = new grpcWeb.MethodDescriptor(
    '/AdminQuestionService/SaveExteriorQuestions',
    grpcWeb.MethodType.UNARY,
    adminbackendproto_AdminQuestionService_pb.SaveExteriorQuestionsRequest,
    adminbackendproto_AdminQuestionService_pb.SaveExteriorQuestionsResponse,
    (request: adminbackendproto_AdminQuestionService_pb.SaveExteriorQuestionsRequest) => {
      return request.serializeBinary();
    },
    adminbackendproto_AdminQuestionService_pb.SaveExteriorQuestionsResponse.deserializeBinary
  );

  saveExteriorQuestions(
    request: adminbackendproto_AdminQuestionService_pb.SaveExteriorQuestionsRequest,
    metadata?: grpcWeb.Metadata | null): Promise<adminbackendproto_AdminQuestionService_pb.SaveExteriorQuestionsResponse>;

  saveExteriorQuestions(
    request: adminbackendproto_AdminQuestionService_pb.SaveExteriorQuestionsRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.RpcError,
               response: adminbackendproto_AdminQuestionService_pb.SaveExteriorQuestionsResponse) => void): grpcWeb.ClientReadableStream<adminbackendproto_AdminQuestionService_pb.SaveExteriorQuestionsResponse>;

  saveExteriorQuestions(
    request: adminbackendproto_AdminQuestionService_pb.SaveExteriorQuestionsRequest,
    metadata?: grpcWeb.Metadata | null,
    callback?: (err: grpcWeb.RpcError,
               response: adminbackendproto_AdminQuestionService_pb.SaveExteriorQuestionsResponse) => void) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ +
          '/AdminQuestionService/SaveExteriorQuestions',
        request,
        metadata || {},
        this.methodDescriptorSaveExteriorQuestions,
        callback);
    }
    return this.client_.unaryCall(
    this.hostname_ +
      '/AdminQuestionService/SaveExteriorQuestions',
    request,
    metadata || {},
    this.methodDescriptorSaveExteriorQuestions);
  }

  methodDescriptorSaveBasementQuestions = new grpcWeb.MethodDescriptor(
    '/AdminQuestionService/SaveBasementQuestions',
    grpcWeb.MethodType.UNARY,
    adminbackendproto_AdminQuestionService_pb.SaveBasementQuestionsRequest,
    adminbackendproto_AdminQuestionService_pb.SaveBasementQuestionsResponse,
    (request: adminbackendproto_AdminQuestionService_pb.SaveBasementQuestionsRequest) => {
      return request.serializeBinary();
    },
    adminbackendproto_AdminQuestionService_pb.SaveBasementQuestionsResponse.deserializeBinary
  );

  saveBasementQuestions(
    request: adminbackendproto_AdminQuestionService_pb.SaveBasementQuestionsRequest,
    metadata?: grpcWeb.Metadata | null): Promise<adminbackendproto_AdminQuestionService_pb.SaveBasementQuestionsResponse>;

  saveBasementQuestions(
    request: adminbackendproto_AdminQuestionService_pb.SaveBasementQuestionsRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.RpcError,
               response: adminbackendproto_AdminQuestionService_pb.SaveBasementQuestionsResponse) => void): grpcWeb.ClientReadableStream<adminbackendproto_AdminQuestionService_pb.SaveBasementQuestionsResponse>;

  saveBasementQuestions(
    request: adminbackendproto_AdminQuestionService_pb.SaveBasementQuestionsRequest,
    metadata?: grpcWeb.Metadata | null,
    callback?: (err: grpcWeb.RpcError,
               response: adminbackendproto_AdminQuestionService_pb.SaveBasementQuestionsResponse) => void) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ +
          '/AdminQuestionService/SaveBasementQuestions',
        request,
        metadata || {},
        this.methodDescriptorSaveBasementQuestions,
        callback);
    }
    return this.client_.unaryCall(
    this.hostname_ +
      '/AdminQuestionService/SaveBasementQuestions',
    request,
    metadata || {},
    this.methodDescriptorSaveBasementQuestions);
  }

}

